/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreeTextAnswerCreatePayloadRequest
 */
export interface FreeTextAnswerCreatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof FreeTextAnswerCreatePayloadRequest
     */
    correctAnswer: string;
    /**
     * 
     * @type {number}
     * @memberof FreeTextAnswerCreatePayloadRequest
     */
    question: number;
}

/**
 * Check if a given object implements the FreeTextAnswerCreatePayloadRequest interface.
 */
export function instanceOfFreeTextAnswerCreatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "correctAnswer" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function FreeTextAnswerCreatePayloadRequestFromJSON(json: any): FreeTextAnswerCreatePayloadRequest {
    return FreeTextAnswerCreatePayloadRequestFromJSONTyped(json, false);
}

export function FreeTextAnswerCreatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeTextAnswerCreatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correctAnswer': json['correct_answer'],
        'question': json['question'],
    };
}

export function FreeTextAnswerCreatePayloadRequestToJSON(value?: FreeTextAnswerCreatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correct_answer': value.correctAnswer,
        'question': value.question,
    };
}

